import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, EmptyState, BaasicButton } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageFooter, PageNavigation } from 'core/layouts';
import { isSome } from 'core/utils';

function ImportPatientDuplicatesTemplate({ listViewStore }) {
    const {
        rootStore,
        tableLoading,
        tableStore,
        loaderStore,
        invalidateRefrerrals
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore} loading={loaderStore.loading}>
            <PageNavigation>
                <BaasicButton 
                className="btn btn--base btn--primary u-mar--left--tny u-flex--last" 
                label={'Refresh Referrals'} 
                icon="u-icon u-icon--sml u-icon--synchronize" 
                onClick={invalidateRefrerrals} />
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()}>
                <div className="card--table u-mar--bottom--med">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        actionsComponent={renderActions}
                        actionHeaderComponent={headerComponent}
                    />
                </div>
            </Content>
            <PageFooter>
                <div>
                    <BaasicButton
                        className='btn btn--base btn--ghost'
                        label={('LIST_LAYOUT.BACK_BUTTON')}
                        onClick={() => rootStore.routerStore.goBack()}
                        icon='u-icon u-icon--xsml u-icon--btn-back'
                    />
                </div>
            </PageFooter>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='IMPORT_PATIENT.LIST.EMPTY_STATE.TITLE' description='IMPORT_PATIENT.LIST.EMPTY_STATE.DESCRIPTION' />
}

ImportPatientDuplicatesTemplate.propTypes = {
    listViewStore: PropTypes.object
};

function headerComponent({ t }){
    return (
        <a className="k-link type--right">{t('GRID.USE_THIS_PATIENT')}</a>
    );
}
headerComponent.propTypes = {
    t: PropTypes.func
};

function renderActions({item, actions, authorization}){
    if (!isSome(actions)) return null;

    const { onEdit } = actions;
    if (!isSome(onEdit)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--merge u-icon--med'
                        label='Use this patient'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    );
}
renderActions.propTypes = {
    item: PropTypes.any,
    actions: PropTypes.any,
    authorization: PropTypes.any
};

export default defaultTemplate(ImportPatientDuplicatesTemplate);